import { SuperListCondition } from "@/includes/logic/FaceControl/conditions/SuperListCondition/SuperListCondition";
import { FaceControlConditionTypes } from "@/includes/types/FaceControl.types";

export class PersonalChannelTitleCondition extends SuperListCondition {
    constructor() {
        super(FaceControlConditionTypes.PersonalChannelTitle);
    }
}